import * as PIXI from "pixi.js";
import "pixi-spine";
import { install } from "@pixi/unsafe-eval";

install(PIXI);

const loader = new PIXI.Loader();

loader.add("follower", "assets/followers/Follower.json", {
  metadata: { spineSkeletonScale: 0.8 },
});

export function loadFollowerAssets() {
  return new Promise((resolve, reject) => {
    loader.load((loader, resources) => {
      resolve(resources);
    });
  });
}

//loader.onProgress.add(() => {
//  console.log("Progress");
//  console.log(loader.progress);
//});

export default loader;
